export const workExperiences = [
  {
    id: 7,
    company: 'UniChat',
    title: 'Full Stack Developer | Project Lead',
    date: 'December 2020 - Present',
    location: 'Remote',
    items: [
      'Leading a team of 3 developers of a chat and tutoring application to be used by UCalgary Engineering Students',
      'Responsible for the full functionality of the real-time chat and authentication system, consisting of 30+ React components combined with Node.js, Socket IO, and Firebase backend logic',
      "Designed ERD's, implemented them using PostgreSQL, and have developed 7 API endpoints in Node.js"
    ]
  },
  {
    id: 8,
    company: 'Lighthouse Labs',
    title: 'Project Evaluator',
    date: 'February 2021 - Present',
    location: 'Remote',
    items: [
      'Perform 10 in-depth code reviews per month of Full Stack projects completed by students and provide a detailed report providing  constructive feedback in areas including version control, code quality, and solution techniques',
      'Project stacks include React, Node.js, Express, PostgreSQL, jQuery, HTML, CSS'
    ]
  },
  {
    id: 1,
    company: 'HiOctave Media',
    title: 'Frontend Developer | Creative Director',
    date: 'Feb 2020 - Present',
    location: 'Calgary, AB',
    items: [
      'Design and develop custom websites and provide digital marketing services for small businesses primarily using JavaScript, SASS, HTML5, and Webflow while progressively introducing React and Material UI into projects',
      'Completed 6 website/marketing projects while managing up to 3 outsourced subcontractorss',
      'Achieved growth of 1000+ organic social media followers and a 30% increase in website traffic and sales for clients',
      'Facilitate all client communications which includes sales, consultation meetings, and client satisfaction',
      'Marketing content creation includes: graphic design, photography, and videography',
    ]
  },
  {
    id: 2,
    company: 'MEG Energy',
    title: 'Mechanical Engineering Intern',
    date: 'Sep 2019 - Dec 2019',
    location: 'Calgary, AB',
    items: [
      "Assisted senior engineers in analyzing mechanical diagrams such as P&ID's, ISO's and General Assemblies to create inspection plans for static and rotating equipment and facility pipelines",
      'Developed 50+ asset inspection profiles on Meridium which were estimated to reduce maintenance costs by $200,000',
      'Collaborated with on-site inspectors to develop an inspection reporting system',
      'Developed site plot plan for the 2020 turnaround work'
    ]
  },
  {
    id: 3,
    company: 'WSP Canada',
    title: 'Mechanical Engineering Intern',
    date: 'May 2019 - Aug 2019',
    location: 'Calgary, AB',
    items: [
      "Worked with senior engineers on the TC Energy Methane Reduction project which reduced asset emissions by 40%",
      "Analyzed 200+ client P&ID's, ISO's, and GA's to identify group piping assemblies that contributed to natural gas leaks to create database-ready data containing technical specifications required to calculate total emissions from each asset",
      "Chosen to train an incoming cohort of interns in project specifications and standards to ensure a smooth turnover",
    ]
  },
  {
    id: 4,
    company: 'University of Calgary',
    title: 'Research Assistant',
    date: 'Jan 2018 - May 2019',
    location: 'Calgary, AB',
    items: [
      "Assisted in the development of algorithms that are executed using MATLAB that perform numerical analyses on data of simulated stratified momentum wakes of turbulent fluid flow",
      "Analyzed over 10TB of real fluid flow data",
      "Examined the accuracy and efficiency of several algorithms and numerical methods",
      "Produced some of the first-ever three-dimensional visualizations of high-Reynolds-number flow",
      "Independently learned graduate-level mathematical concepts and apply them in the analyses",
    ]
  },
  {
    id: 5,
    company: 'University of Calgary',
    title: 'Learning Assistant',
    date: 'Sep 2018 - Apr 2019',
    location: 'Calgary, AB',
    items: [
      "Provide tutoring services to first- and second-year engineering students at the school's Engineering Academic Success Centre",
      "Assisted with programming fundamentals, dynamics, linear algebra, mechanics of solids, and circuits",
    ]
  },
  {
    id: 6,
    company: "The Ceili's Group",
    title: 'Assistant Manager',
    date: 'May 2016 - Sep 2017',
    location: 'Calgary, AB',
    items: [
      "The youngest employee to take on a leadership role (after promotion) at the establishment",
      "Oversaw the daily operation while supervising up to 15 employees",
      "Trained 5 new employees by familiarizing them with the business structure and POS Systems",
      "Helped reduce labour costs by ~20 percent by determining more efficient restaurant structures",
    ]
  },
]